<template>
  <v-container>
    <img class="breadcrumb2" src="../assets/breadcrumb2.svg" />
    <h1 class="title mt-2">Who is the primary contact for the business?</h1>
    <h2 class="subheading">
      This is the person we will contact with all status updates related to the order
    </h2>
    <v-form ref="form">
      <v-text-field
        v-model="first"
        :rules="[required]"
        name="first"
        label="First Name"
        browser-autocomplete="given-name"
        data-cy="first"
      />
      <v-text-field
        v-model="last"
        :rules="[required]"
        name="last"
        label="Last Name"
        browser-autocomplete="family-name"
        data-cy="last"
      />
      <v-text-field
        v-model="phone"
        :rules="[required, phoneTest]"
        name="phone"
        label="Phone Number"
        browser-autocomplete="tel-national"
        type="tel"
        mask="phone"
        data-cy="phone"
      />
      <v-text-field
        :rules="[required, emailTest]"
        name="email"
        label="Email"
        type="email"
        browser-autocomplete="email"
        data-cy="email"
      />
      <v-layout justify-space-around>
        <v-btn @click="$router.go(-1);">Back</v-btn>
        <v-btn color="info" @click="done">Continue</v-btn>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/database';
import { mapState } from 'vuex';
import { emailRegex } from './util';

const db = firebase.database;

export default {
  data: () => ({
    first: '',
    last: '',
    phone: '',
    email: '',
  }),
  computed: mapState(['token']),
  methods: {
    async done() {
      if (!this.$refs.form.validate()) return;
      await db()
        .ref(`info/${this.token}`)
        .update({ name: this.$data });
      this.$router.push({ path: 'stage3/info' });
    },
    required: field => !!field || 'Field is required',
    emailTest: field => emailRegex.test(field) || 'Email must be valid',
    phoneTest: field => /\d{10}/.test(field) || 'Phone must be valid',
  },
};
</script>
